import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../core/layout/Card';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import GlobalAverageLevelChartContainer from './charts/GlobalAverageLevelChartContainer';
import GlobalErrorsPerAbilityChartContainer from './charts/GlobalErrorsPerAbilityChartContainer';
import GlobalErrorsPerGrammarChartContainer from './charts/GlobalErrorsPerGrammarChartContainer';
import GlobalPlacementTestsPerLevelChartContainer from './charts/GlobalPlacementTestsPerLevelChartContainer';

export default function PlacementTestReportGlobalTab(props) {
  return (
    <Card
      title={props.isFetching ? 'Fetching data...' : `The report is showing data from ${props.total} Placement Tests`}
    >
      <Row>
        <Column size={2}>
          <GlobalAverageLevelChartContainer />
        </Column>
        <Column size={3.5}>
          <GlobalPlacementTestsPerLevelChartContainer />
        </Column>
        <Column size={2.5}>
          <GlobalErrorsPerAbilityChartContainer />
        </Column>
        <Column size={4}>
          <GlobalErrorsPerGrammarChartContainer />
        </Column>
      </Row>
    </Card>
  );
}

PlacementTestReportGlobalTab.propTypes = {
  total: PropTypes.number,
  isFetching: PropTypes.bool,
};

PlacementTestReportGlobalTab.defaultProps = {
  isFetching: false,
};
